import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VDialog,
    {
      attrs: { "max-width": "820", persistent: "", scrollable: "" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        VCard,
        { staticClass: "activity-timeline-dialog" },
        [
          _c(
            VCardTitle,
            { staticClass: "headline" },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("create_attribute.activity_timeline.title")) +
                  " "
              ),
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: { icon: "", disabled: _vm.bulkRetryActive },
                  on: { click: _vm.close },
                },
                [_c(VIcon, [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            VCardText,
            [
              _vm.recordStatusId
                ? _c(
                    "div",
                    { staticClass: "record-status-row mb-3" },
                    [
                      _c("span", { staticClass: "record-status-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("create_attribute.headers.status"))
                        ),
                      ]),
                      _c(
                        VChip,
                        {
                          attrs: {
                            small: "",
                            color: _vm.recordStatusColor,
                            "text-color": "white",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.recordStatusText) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.loading && !_vm.executions.length
                ? _c(VProgressLinear, {
                    staticClass: "mb-4",
                    attrs: { indeterminate: "", color: "primary" },
                  })
                : _vm._e(),
              _vm.error
                ? _c(
                    VAlert,
                    {
                      staticClass: "mb-3",
                      attrs: { type: "error", outlined: "", dense: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.error) + " ")]
                  )
                : _vm._e(),
              !_vm.loading && !_vm.executions.length && !_vm.error
                ? _c("div", { staticClass: "text-center grey--text py-6" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("create_attribute.activity_timeline.empty")
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm._l(_vm.executions, function (exec) {
                return _c(
                  "div",
                  {
                    key: exec.execution_id,
                    staticClass: "execution-row mb-2",
                    class: { "execution-row--active": exec.is_active },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "execution-header",
                        on: {
                          click: function ($event) {
                            return _vm.toggleExecution(exec.execution_id)
                          },
                        },
                      },
                      [
                        _c(
                          VIcon,
                          {
                            staticClass: "mr-2",
                            attrs: {
                              small: "",
                              color: _vm.execTypeColor(exec.type),
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.execTypeIcon(exec.type)) + " "
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "execution-type" }, [
                          _vm._v(_vm._s(_vm.execTypeLabel(exec.type))),
                        ]),
                        _c(
                          "span",
                          { staticClass: "text-caption grey--text ml-2" },
                          [_vm._v(_vm._s(_vm.formatTimestamp(exec.started_at)))]
                        ),
                        exec.total_periods
                          ? _c(
                              "span",
                              { staticClass: "text-caption grey--text ml-2" },
                              [
                                _vm._v(
                                  " · " +
                                    _vm._s(exec.completed_periods) +
                                    "/" +
                                    _vm._s(exec.total_periods) +
                                    " " +
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.activity_timeline.periods"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(VSpacer),
                        _c(VIcon, { staticClass: "ml-2" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isExpanded(exec.execution_id)
                                  ? "mdi-chevron-up"
                                  : "mdi-chevron-down"
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(VExpandTransition, [
                      _vm.isExpanded(exec.execution_id)
                        ? _c(
                            "div",
                            { staticClass: "execution-body pa-3" },
                            [
                              exec.type === "load_months"
                                ? _c(
                                    VAlert,
                                    {
                                      staticClass: "mb-3 text-caption",
                                      attrs: {
                                        dense: "",
                                        outlined: "",
                                        type: "info",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "create_attribute.activity_timeline.incremental_note"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                VTimeline,
                                {
                                  staticClass: "execution-timeline",
                                  attrs: { dense: "", "align-top": "" },
                                },
                                _vm._l(exec.steps, function (step, stepIdx) {
                                  return _c(
                                    VTimelineItem,
                                    {
                                      key: exec.execution_id + "-" + step.step,
                                      attrs: {
                                        color: _vm.stepColor(step.status),
                                        small: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "icon",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "caption font-weight-bold white--text",
                                                  },
                                                  [_vm._v(_vm._s(stepIdx + 1))]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        VRow,
                                        {
                                          attrs: { dense: "", align: "center" },
                                        },
                                        [
                                          _c(
                                            VCol,
                                            { attrs: { cols: "5" } },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.stepLabel(step.step)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            VCol,
                                            { attrs: { cols: "3" } },
                                            [
                                              _c(
                                                VChip,
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color: _vm.stepColor(
                                                      step.status
                                                    ),
                                                    "text-color": "white",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "create_attribute.activity_timeline.status." +
                                                            step.status
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VCol,
                                            {
                                              staticClass:
                                                "text-caption grey--text",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatTimestamp(
                                                      step.timestamp
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            VCol,
                                            {
                                              staticClass: "text-right",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _vm.canRetryStep(exec, step)
                                                ? _c(
                                                    VBtn,
                                                    {
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "warning",
                                                        outlined: "",
                                                        loading:
                                                          _vm.retryingExec ===
                                                            exec.execution_id &&
                                                          _vm.retryingStep ===
                                                            step.step &&
                                                          !_vm.bulkRetryActive,
                                                        disabled:
                                                          _vm.bulkRetryActive,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.retryStep(
                                                            exec,
                                                            step.step
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "create_attribute.activity_timeline.retry"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.stepDetailText(step) &&
                                      (step.status === "failed" ||
                                        step.status === "skipped")
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "text-caption mt-1",
                                              class:
                                                step.status === "failed"
                                                  ? "error--text"
                                                  : "warning--text",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.stepDetailText(step)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.duplicateGroups(step).length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "duplicate-summary mt-2",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "duplicate-summary__title",
                                                },
                                                [
                                                  _vm._v(
                                                    " Duplicados encontrados "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                VExpansionPanels,
                                                {
                                                  staticClass:
                                                    "duplicate-summary__panels",
                                                  attrs: { flat: "" },
                                                },
                                                _vm._l(
                                                  _vm.duplicateGroups(step),
                                                  function (group) {
                                                    return _c(
                                                      VExpansionPanel,
                                                      {
                                                        key: group.category,
                                                        staticClass:
                                                          "duplicate-summary__group",
                                                      },
                                                      [
                                                        _c(
                                                          VExpansionPanelHeader,
                                                          {
                                                            staticClass:
                                                              "duplicate-summary__header",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "duplicate-summary__category",
                                                              },
                                                              [
                                                                _c(
                                                                  VIcon,
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                      color:
                                                                        "error",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-tag-alert-outline"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      group.category
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "duplicate-summary__count",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          group
                                                                            .attributes
                                                                            .length
                                                                        ) +
                                                                        " atributo(s) "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          VExpansionPanelContent,
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "duplicate-summary__attributes",
                                                              },
                                                              [
                                                                _vm._l(
                                                                  group.attributes,
                                                                  function (
                                                                    attribute
                                                                  ) {
                                                                    return _c(
                                                                      VChip,
                                                                      {
                                                                        key:
                                                                          group.category +
                                                                          "-" +
                                                                          attribute,
                                                                        staticClass:
                                                                          "mr-1 mb-1",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          color:
                                                                            "error",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              attribute
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                !group
                                                                  .attributes
                                                                  .length
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-caption grey--text",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Categoria duplicada "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              2
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      step.step === "aws_pipeline" &&
                                      step.aws_timeline &&
                                      step.aws_timeline.length
                                        ? _c(
                                            VExpansionPanels,
                                            {
                                              staticClass: "mt-2",
                                              attrs: { flat: "" },
                                            },
                                            [
                                              _c(
                                                VExpansionPanel,
                                                [
                                                  _c(
                                                    VExpansionPanelHeader,
                                                    {
                                                      staticClass:
                                                        "py-1 text-caption",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "create_attribute.activity_timeline.aws_timeline_title"
                                                            )
                                                          ) +
                                                          " (" +
                                                          _vm._s(
                                                            step.aws_timeline
                                                              .length
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    VExpansionPanelContent,
                                                    [
                                                      _c(
                                                        VList,
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: { dense: "" },
                                                        },
                                                        _vm._l(
                                                          step.aws_timeline,
                                                          function (evt, idx) {
                                                            return _c(
                                                              VListItem,
                                                              {
                                                                key: idx,
                                                                staticClass:
                                                                  "py-0",
                                                              },
                                                              [
                                                                _c(
                                                                  VListItemIcon,
                                                                  {
                                                                    staticClass:
                                                                      "mr-2 my-1",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      VIcon,
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            _vm.awsStateColor(
                                                                              evt.aws_state
                                                                            ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.awsStateIcon(
                                                                                evt.aws_state
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  VListItemContent,
                                                                  {
                                                                    staticClass:
                                                                      "py-1",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      VListItemTitle,
                                                                      {
                                                                        staticClass:
                                                                          "text-caption",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                evt.aws_state
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        evt.process_date
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "grey--text",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " · " +
                                                                                    _vm._s(
                                                                                      evt.process_date
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                    evt.detail
                                                                      ? _c(
                                                                          VListItemSubtitle,
                                                                          {
                                                                            staticClass:
                                                                              "text-caption",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  evt.detail
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      VListItemSubtitle,
                                                                      {
                                                                        staticClass:
                                                                          "text-caption grey--text",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.formatTimestamp(
                                                                                evt.timestamp
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                              _vm.hasRetryableSteps(exec) && _vm.canRetryAll
                                ? _c(
                                    "div",
                                    { staticClass: "text-right mt-2" },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "warning",
                                            outlined: "",
                                            loading:
                                              _vm.bulkRetryActive &&
                                              _vm.retryingExec ===
                                                exec.execution_id,
                                            disabled:
                                              _vm.bulkRetryActive &&
                                              _vm.retryingExec !==
                                                exec.execution_id,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.retryAllForExec(exec)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "create_attribute.activity_timeline.retry_from_step",
                                                  {
                                                    step: _vm.firstRetryableStepNumber(
                                                      exec
                                                    ),
                                                  }
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              }),
              _vm.canLoadMore
                ? _c(
                    "div",
                    { staticClass: "text-center mt-3" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            small: "",
                            outlined: "",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.loadMore },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "create_attribute.activity_timeline.load_more"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            VCardActions,
            [
              _c(VSpacer),
              _c(
                VBtn,
                {
                  attrs: {
                    text: "",
                    color: "primary",
                    loading: _vm.loading,
                    disabled: _vm.bulkRetryActive,
                  },
                  on: { click: _vm.refresh },
                },
                [_vm._v(" " + _vm._s(_vm.$t("btns.refresh")) + " ")]
              ),
              _c(
                VBtn,
                {
                  attrs: { text: "", disabled: _vm.bulkRetryActive },
                  on: { click: _vm.close },
                },
                [_vm._v(" " + _vm._s(_vm.$t("btns.close")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }